import $ from 'jquery';
import 'bootstrap';
import { uniq } from 'lodash';

import { cookieGetItem } from '../../cookie';
import { USER_INFO, CLASS_DOMAIN } from '../../constants';

export const init = () => {
    let selectedList1 = [];
    let selectedList2 = [];
    let currentTab = 1;
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        // console.log(e.target);
        currentTab = $(e.target).data('v');
        if(currentTab == 1){
            $('.display-4').html('2024考研VIP定向领学计划');
        } else {
            $('.display-4').html('2024考研VIP管综领学计划');
        }
        // console.log(currentTab)
    })
    const doDiscount = function(arr){
        let discount = 0;
        let stp = 0;
        let sum = 0;
        let add = 0;
        // console.log(arr)
        if(arr.length == 1){
            discount = 0;
            stp = arr[0].stp;
            sum = stp;
            add = 0;
        } else if(arr.length == 2){
            if(arr.find(v => v.gid == 5) && arr.find(v => v.gid == 6)){
                discount = 2000;
            } 
            if(arr.find(v => v.gid == 1) && arr.find(v => v.gid == 2)){
                discount = 1500;
            } else if(arr.find(v => v.gid == 1) && arr.find(v => v.gid == 3)){
                let elem = arr.find(v => v.gid == 3);
                if(elem.id =='7470' || elem.id =='7471'){
                    discount = 2000;
                } else {
                    discount = 2000;
                }
            } else if(arr.find(v => v.gid == 2) && arr.find(v => v.gid == 3)){
                discount = 2000;
            } else if(arr.find(v => v.gid == 1) && arr.find(v => v.gid == 4)){
                let elem = arr.find(v => v.gid == 4);
                if(elem.id =='7282' || elem.id =='7283'){
                    discount = 5000;
                } else if(elem.id =='7281'){
                    discount = 3000;
                }
            } else if(arr.find(v => v.gid == 2) && arr.find(v => v.gid == 4)){
                let elem = arr.find(v => v.gid == 4);
                if(elem.id =='7282' || elem.id =='7283'){
                    discount = 4500;
                } else if(elem.id =='7281'){
                    discount = 2500;
                }
            } else if(arr.find(v => v.gid == 3) && arr.find(v => v.gid == 4)){
                let elem1 = arr.find(v => v.gid == 3);
                let elem2 = arr.find(v => v.gid == 4);
                if(elem1.id = '7456' && (elem2.id =='7282' || elem2.id =='7283')){
                    discount = 5000;
                } else if(elem2.id =='7281'){
                    discount = 3000;
                }
            } else if(arr.find(v => v.gid == 3) && arr.find(v => v.gid == 4)){
                let elem1 = arr.find(v => v.gid == 3);
                let elem2 = arr.find(v => v.gid == 4);
                if((elem1.id =='7470' || elem1.id =='7471') && (elem2.id =='7282' || elem2.id =='7283')){
                    discount = 5000;
                } else if(elem2.id =='7281'){
                    discount = 3000;
                }
            }
            add = 1000;
            stp = arr[0].stp + arr[1].stp;
            sum = stp - discount + add;
        } else if (arr.length == 3){
            if(arr.find(v => v.gid == 1) && arr.find(v => v.gid == 2) && arr.find(v => v.gid == 3)){
                discount = 3000;
            } else  if(arr.find(v => v.gid == 1) && arr.find(v => v.gid == 2) && arr.find(v => v.gid == 4)){
                let elem2 = arr.find(v => v.gid == 4);
                if(elem2.id =='7282' || elem2.id =='7283'){
                    discount = 5500;
                } else if(elem2.id =='7281'){
                    discount = 3500;
                }
            } else  if(arr.find(v => v.gid == 2) && arr.find(v => v.gid == 3) && arr.find(v => v.gid == 4)){
                let elem2 = arr.find(v => v.gid == 4);
                if(elem2.id =='7282' || elem2.id =='7283'){
                    discount = 5500;
                } else if(elem2.id =='7281'){
                    discount = 3500;
                }
            } else  if(arr.find(v => v.gid == 1) && arr.find(v => v.gid == 3) && arr.find(v => v.gid == 4)){
                let elem2 = arr.find(v => v.gid == 4);
                if(elem2.id =='7282' || elem2.id =='7283'){
                    discount = 6000;
                } else if(elem2.id =='7281'){
                    discount = 4000;
                }
            }
            stp = arr[0].stp + arr[1].stp + arr[2].stp;
            add = 1500;
            sum = stp - discount + add;
        } else if (arr.length == 4){
            if(arr.find(v => v.gid == 1) && arr.find(v => v.gid == 2) && arr.find(v => v.gid == 3) && arr.find(v => v.gid == 4)){
                let elem1 = arr.find(v => v.gid == 3);
                let elem2 = arr.find(v => v.gid == 4);
                if(elem1.id == '7456' && (elem2.id =='7282' || elem2.id =='7283')){
                    discount = 7000;
                } else if((elem1.id =='7470' || elem1.id =='7471') && (elem2.id =='7282' || elem2.id =='7283')){
                    discount = 7000;
                } else if(elem1.id = '7456' && (elem2.id =='7281')){
                    discount = 5000;
                } else if((elem1.id =='7470' || elem1.id =='7471') && (elem2.id =='72821')){
                    discount = 5000;
                } 
            }
            add = 3000
            stp = arr[0].stp + arr[1].stp + arr[2].stp + arr[3].stp;
            sum = stp - discount + add;
        }
        
        if(sum){
            if(discount){
                $(`#Group-${currentTab} ._ap`).html(`应付金额：<br class="d-md-none">${stp}-${discount - add}=<span class="h4 mb-0 text-danger">￥${sum}</span>`);
                $(`#Group-${currentTab} ._el_hint`).html(`您已享受：<span class="text-orange " >${arr.length}科联报减${discount - add}元</span>`)
            } else {
                $(`#Group-${currentTab} ._ap`).html(`应付金额：<br class="d-md-none"><span class="h4 mb-0 text-danger">￥${sum}</span>`);
                $(`#Group-${currentTab} ._el_hint`).html(``)
            
            }
            
        } else {
            $(`#Group-${currentTab} ._ap`).html(`应付金额：<span class="h4 mb-0 text-danger">￥${sum}</span>`);
            $(`#Group-${currentTab} ._el_hint`).html(``)
        }
    }

    $(`#Group-1 ._topay`).on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if(selectedList1.length){
            window.location.href = `${CLASS_DOMAIN}/order/${selectedList1.map(v => v.id).sort().join('-')}`;
        } else {
            alert('请选择一个科目')
        }
    })
    $(`#Group-2 ._topay`).on('click', function(e){
        e.stopPropagation();
        if(selectedList2.length){
            window.location.href = `${CLASS_DOMAIN}/order/${selectedList2.map(v => v.id).sort().join('-')}`;
        } else {
            alert('请选择一个科目')
        }
    })

    $('.gg01 .dropdown-menu a').on('click', function(e){
        let elem = $(this);
        e.preventDefault();
        e.stopPropagation();
        // console.log(elem.data('id'));
        let checkbox = elem.parent().parent().parent().find('input');
        if(elem.data('id')){
            if(!checkbox.is(':checked')) {
                checkbox.prop('checked', true);
            }
            elem.parent().parent().find('button').html(elem.html());
        }else {
            if(checkbox.is(':checked')) {
                checkbox.prop('checked', false);
            }
            elem.parent().parent().find('button').html(elem.html().replace(/-/g, ''));
        }
        if(currentTab == 1){
            selectedList1 = selectedList1.filter(x => x.gid != elem.data('gid'));
            // console.log(elem.data('gid'),  selectedList1)
            if(elem.data('id')){
                selectedList1.push({
                    stp: elem.data('stp'),
                    discount: elem.data('discount'),
                    id:  elem.data('id'),
                    gid: elem.data('gid'),
                })
            }
            
        } else {
            selectedList2 = selectedList2.filter(x => x.gid != elem.data('gid'));
            if(elem.data('id')){
                selectedList2.push({
                    stp: elem.data('stp'),
                    discount: elem.data('discount'),
                    id:  elem.data('id'),
                    gid: elem.data('gid'),
                })
            }
        }
        doDiscount(currentTab == 1? selectedList1: selectedList2)
        elem.parent().parent().find('button').dropdown('toggle')
    });

    $('.gg01').find('input').on('change', function(e){
        let vHtml = '';
        let elem = $(this).parent().find('.dropdown-item').eq(1);
        if($(this).is(':checked')) {
            vHtml = elem.html();
            if(currentTab == 1){
                selectedList1.push({
                    stp: elem.data('stp'),
                    discount: elem.data('discount'),
                    id:  elem.data('id'),
                    gid: elem.data('gid'),
                })
            } else {
                selectedList2.push({
                    stp: elem.data('stp'),
                    discount: elem.data('discount'),
                    id:  elem.data('id'),
                    gid: elem.data('gid'),
                })
            }
        } else {
            vHtml = $(this).parent().find('.dropdown-item').eq(0).html().replace(/-/g, '');
            if(currentTab == 1){
                selectedList1 = selectedList1.filter(x => x.gid != $(this).data('gid'));
            } else {
                selectedList2 = selectedList2.filter(x => x.gid != $(this).data('gid'));
            }
        }
        $(this).parent().find('button').html(vHtml);
        doDiscount(currentTab == 1? selectedList1: selectedList2)
    });
};


